import React, { useState, useEffect, useCallback } from 'react';
import { useData } from '../context/DataContext'; // Импортируем useData
import StoriesCarousel from './StoriesCarousel';
import StoryViewer from './StoryViewer';
import './Stories.css';

const StoriesComponent = () => {
  // Получаем данные и состояния из DataContext
  // fetchStoriesData и storiesLoaded были удалены, так как не используются здесь напрямую
  const { stories, areStoriesLoading, storiesError } = useData();

  const [activeStory, setActiveStory] = useState(null);
  const [activeItems, setActiveItems] = useState([]);
  const isMounted = React.useRef(true); // Для асинхронных операций внутри компонента, если есть

  // Формирование полного URL для ресурсов (остается локальным, если не нужен глобально)
  const getFullUrl = useCallback((url) => {
    if (!url) return '';
    if (url.startsWith('/')) return `${window.location.origin}${url}`;
    return url;
  }, []);

  // Функция для предварительной загрузки изображений (остается локальной)
  // Она будет использовать 'stories' из контекста
  const preloadStoryImages = useCallback((storiesData) => {
    if (!storiesData || storiesData.length === 0) return;
    const imageUrls = [];
    storiesData.forEach(story => {
      if (story.items && story.items.length > 0) {
        story.items.forEach(item => {
          if (item.type === 'image' && item.url) {
            imageUrls.push(getFullUrl(item.url));
          }
        });
      }
    });

    if (imageUrls.length === 0) return;
    const preloadPromises = imageUrls.map(url => {
      return new Promise((resolve) => {
        const img = new Image();
        img.onload = () => resolve(url);
        img.onerror = () => resolve(null);
        img.src = url;
      });
    });
    Promise.all(preloadPromises).then(results => {
      if (!isMounted.current) return;
      // Предварительная загрузка изображений завершена
    });
  }, [getFullUrl]);

  // useEffect для вызова fetchStoriesData был удален, 
  // так как DataContext теперь управляет начальной загрузкой данных.
  // Компонент StoriesComponent просто потребляет stories, areStoriesLoading, storiesError, storiesLoaded из DataContext.

  // Предзагрузка изображений, когда истории из контекста обновляются и компонент смонтирован
  useEffect(() => {
    isMounted.current = true; // Устанавливаем при монтировании
    if (stories && stories.length > 0 && isMounted.current) {
      preloadStoryImages(stories);
    }
  }, [stories, preloadStoryImages]);


  const handleStorySelect = useCallback((index) => {
    const selectedStory = stories[index];
    if (selectedStory && selectedStory.items) {
      setActiveStory(selectedStory);
      setActiveItems(selectedStory.items);
    }
  }, [stories]);

  const handleCloseStory = useCallback(() => {
    setActiveStory(null);
    setActiveItems([]);
  }, []);

  // Используем areStoriesLoading и storiesError из DataContext
  return (
    <div className="stories-wrapper">
      <StoriesCarousel
        stories={stories}
        loading={areStoriesLoading} // Используем состояние из контекста
        error={storiesError}       // Используем состояние из контекста
        onStorySelect={handleStorySelect}
      />
      {activeStory && (
        <StoryViewer
          activeStory={activeStory}
          activeItems={activeItems}
          onClose={handleCloseStory}
          getFullUrl={getFullUrl} // Передаем локальную функцию
        />
      )}
    </div>
  );
};

export default StoriesComponent;
